import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M9.0589 18.923C8.8059 18.923 8.5519 18.826 8.3579 18.634L2.3919 12.705C2.0019 12.318 1.9999 11.688 2.3879 11.299C2.7759 10.91 3.4049 10.907 3.7939 11.295L9.0559 16.524L20.2029 5.36804C20.5919 4.97904 21.2209 4.98004 21.6099 5.36804C21.9989 5.75604 21.9989 6.38604 21.6109 6.77404L9.7619 18.63C9.5679 18.825 9.3129 18.922 9.0589 18.922V18.923Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Checkmark');

export default Icon;
